import React, { useState, useEffect } from 'react';
import { Modal, Button, __experimentalScrollable as Scrollable, TabPanel, TextControl, SelectControl, CheckboxControl, Flex, FlexBlock, FlexItem, FormTokenField } from '@wordpress/components';
import Cookies from 'js-cookie';

const FilterModal = ({ filtersFields, isOpen, onClose, onApplyFilter }) => {
    const [filters, setFilters] = useState({});

    useEffect(() => {
        if (isOpen) {
            const savedFilters = Cookies.get('product_filters');
            if (savedFilters) {
                try {
                    setFilters(JSON.parse(savedFilters));
                } catch (e) {
                    setFilters({});
                }
            } else {
                setFilters({});
            }
        }
    }, [isOpen]);

    const handleInputChange = (field, value) => {
        const isOperator = field.endsWith('_operator');
        const key = isOperator ? field.replace('_operator', '') : field;

        setFilters(prev => {
            const newFilters = { ...prev };
            if (!newFilters[key]) {
                newFilters[key] = {};
            }

            if (isOperator) {
                newFilters[key].operator = value;
            } else {
                newFilters[key].value = value;
            }

            // If a value is entered and there is no operator, set a default one.
            if (newFilters[key].value && !newFilters[key].operator) {
                newFilters[key].operator = 'like';
            }

            if (!isOperator && (value === '' || value === null || value === undefined)) {
                delete newFilters[key].value;
            }

            if (Object.keys(newFilters[key]).length === 0) {
                delete newFilters[key];
            }

            return newFilters;
        });
    };

    const handleMultipleCheckboxChange = (key, optionValue) => {
        setFilters(prev => {
            const newFilters = { ...prev };
            if (!newFilters[key]) {
                newFilters[key] = { operator: 'in', value: [] };
            }

            const existingValues = newFilters[key].value || [];
            const newValues = existingValues.includes(optionValue)
                ? existingValues.filter(v => v !== optionValue)
                : [...existingValues, optionValue];

            if (newValues.length > 0) {
                newFilters[key].value = newValues;
            } else {
                delete newFilters[key];
            }

            return newFilters;
        });
    };

    const handleApplyFilter = () => {
        const activeFilters = {};
        for (const key in filters) {
            const filter = filters[key];
            if (filter.value !== undefined && filter.value !== null && filter.value !== '' && (!Array.isArray(filter.value) || filter.value.length > 0)) {
                activeFilters[key] = filter;
            }
        }
        Cookies.set('product_filters', JSON.stringify(activeFilters), { expires: 7 });
        onApplyFilter(activeFilters);
        onClose();
    };

    const handleClearAll = () => {
        setFilters({});
        Cookies.remove('product_filters');
        onApplyFilter({});
    };

    if (!isOpen) return null;

    const tabs = Object.keys(filtersFields).map(category => ({
        name: category.toLowerCase().replace(/\s+/g, '-'),
        title: category,
        className: `tab-${category.toLowerCase().replace(/\s+/g, '-')}`
    }));

    return (
        <Modal
            title="Filter Products"
            onRequestClose={onClose}
            style={{
                maxWidth: '1000px',
                width: '90%',
                minHeight: '80vh',
                overflowY: 'auto',
            }}
        >
            <TabPanel
                className="filter-categories-tab-panel"
                activeClass="is-active"
                tabs={tabs}
            >
                {(tab) => {
                    const categoryTitle = tab.title;
                    const fields = filtersFields[categoryTitle];
                    return (
                        <div style={{ marginTop: '20px' }}>
                           
                                {fields.map((column) => (
                                   
                                        <Flex align=""
  gap="5"
  justify="" key={column.accessor}>
                                            <FlexItem  style={{ width: '150px' }} >
                                                <strong style={{ marginBottom: '8px' }}>
                                                    {column.title}
                                                </strong>
                                            </FlexItem>
                                            
                                                {(column.operator === 'select') && (
                                                    <FlexItem  style={{ width: '80px' }}>
                                                    <SelectControl
                                                        value={filters[column.accessor]?.operator || 'like'}
                                                        options={[
                                                            ...Object.entries(column.operatorOption || {}).map(([value, label]) => ({ label, value }))
                                                        ]}
                                                        onChange={(value) =>
                                                            handleInputChange(column.accessor + '_operator', value)
                                                        }
                                                    />
                                                     </FlexItem>
                                                )}

                                               {column.operator === 'between' && (
                                                 <FlexItem  style={{ width: '80px' }}>
                                                    <Flex align="" gap="5">
                                                        {column.between.map(between_col => (
                                                            <FlexItem key={between_col.accessor} style={{ minWidth: '150px' }}>
                                                                <TextControl
                                                                    label={between_col.title}
                                                                    type={between_col.inputType}
                                                                    value={filters[between_col.accessor]?.value || ''}
                                                                    onChange={(value) =>
                                                                        handleInputChange(between_col.accessor, value)
                                                                    }
                                                                />
                                                            </FlexItem>
                                                        ))}
                                                    </Flex>
                                                    </FlexItem>
                                                )}

                                             <FlexItem>  
                                                
                                                {(column.operator !== 'between' && (column.inputType === 'text' ||
                                                    column.inputType === 'number' ||
                                                    column.inputType === 'datetime-local')) && (
                                                    <TextControl
                                                        type={column.inputType}
                                                        value={filters[column.accessor]?.value || ''}
                                                        onChange={(value) =>
                                                            handleInputChange(column.accessor, value)
                                                        }
                                                    />
                                                )}
                                                
                                                {column.inputType === 'select' && (
                                                    <SelectControl
                                                        value={filters[column.accessor]?.value || ''}
                                                        options={[
                                                            { label: '-- None --', value: '' },
                                                            ...column.options
                                                        ]}
                                                        onChange={(value) =>
                                                            handleInputChange(column.accessor, value)
                                                        }
                                                    />
                                                )}

                                                {column.inputType === 'checkbox' && (
                                                    <CheckboxControl
                                                        label="Enabled"
                                                        checked={Boolean(filters[column.accessor]?.value)}
                                                        onChange={(isChecked) =>
                                                            handleInputChange(column.accessor, isChecked)
                                                        }
                                                    />
                                                )}

                                                {column.inputType === 'multipleCheckbox' && (
                                                    <FormTokenField
                                                        __experimentalExpandOnFocus
                                                        label=""
                                                        value={(filters[column.accessor]?.value || []).map(value => {
                                                            const option = column.options.find(opt => opt.value === value);
                                                            return option ? option.label : value;
                                                        })}
                                                        suggestions={column.options.map(option => option.label)}
                                                        onChange={(tokens) => {
                                                            const values = tokens
                                                                .map(token => {
                                                                    const option = column.options.find(opt => opt.label === token);
                                                                    return option ? option.value : null;
                                                                })
                                                                .filter(value => value !== null); // Only keep valid values
                                                            handleInputChange(column.accessor, values);
                                                        }}
                                                        maxSuggestions={20}
                                                        __experimentalValidateInput={(value) => 
                                                            column.options.some(opt => opt.label.toLowerCase() === value.toLowerCase())
                                                        }
                                                    />
                                                )}
                                            </FlexItem>
                                        </Flex>
                                   
                                ))}
                           
                        </div>
                    );
                }}
            </TabPanel>
            <div style={{ textAlign: 'right', marginTop: '25px', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                <Button isPrimary onClick={handleApplyFilter}>
                    Apply Filter
                </Button>
                <Button
                    isDestructive
                    onClick={handleClearAll}
                    style={{ background: '#d63638', borderColor: '#d63638', color: '#fff' }}
                >
                    Clear All
                </Button>
            </div>
        </Modal>
    );
};

export default FilterModal;